import { apiClient } from './client';
import { OlyPlay } from '@raketta/shared';

export interface OlympusSpinResult {
  betId: number;
  play: OlyPlay;
  totalWin: string;
  amount: string;
  newBalance: string;
  nonce: number;
  serverSeedHash: string;
  clientSeed: string;
  createdAt: string;
}

export const olympusApi = {
  spin: (amount: string, buyBonus = false) =>
    apiClient.post<OlympusSpinResult>('/slots/olympus/spin', { amount, buyBonus }).then((r) => r.data),
};
